import Flx from "../../layout/Flx";
// src/components/LoanFilesTable/hooks/useColumnDefs.js
import {
  AutoAwesomeOutlined,
  CheckOutlined,
  ErrorOutline,
  GavelOutlined,
  HourglassEmptyOutlined,
  ManageSearchOutlined,
} from "@mui/icons-material";
import isNil from "lodash/isNil";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../_src_shared/utils/functions/formatDateTime";
import { getUserFullNameFromEmail } from "../../../utils/functions/getUserFullNameFromEmail";

const CellRendererLoanFileStatus = ({ params, editing }) => {
  const users = useSelector((state) => state.users);

  // const updatedByUserEmail =
  //   params?.data?.documentStatusUpdateBy || params?.data?.updatedBy;
  const updatedByUserEmail = params?.data?.documentStatusUpdateBy;

  const updatedByUserDate =
    params?.data?.documentStatusUpdateDate || params?.data?.modifiedDate;

  let statusValue = params?.data?.documentStatus;
  let iconValue = null;

  const formattedUserName = getUserFullNameFromEmail(users, updatedByUserEmail);

  if (params?.data?.documentStatus === "New Upload") {
    iconValue = <AutoAwesomeOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Initial Reviewed") {
    iconValue = <ManageSearchOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Legal Reviewed") {
    iconValue = <GavelOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Pending Review") {
    iconValue = <GavelOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Expired") {
    iconValue = <HourglassEmptyOutlined className="thin" />;
  }
  if (params?.data?.documentStatus === "Rejected") {
    iconValue = <ErrorOutline className="thin" />;
  }
  if (params?.data?.documentStatus === "Incomplete") {
    iconValue = <ErrorOutline className="thin" />;
  }
  if (params?.data?.documentStatus === "Accepted") {
    iconValue = <CheckOutlined className="thin" />;
  }

  return (
    <Flx column gap={0} sx={{ width: "100%", overflow: "hidden" }}>
      <Flx
        ac
        g={0.4}
        sx={{
          ".MuiSvgIcon-root": {
            fontSize: "13px",
          },
        }}
      >
        {iconValue}
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: "16px",
            fontSize: "12px",
          }}
        >
          {statusValue}
        </span>
      </Flx>
      {isNil(statusValue) ||
      statusValue === "New Upload" ||
      editing ||
      isNil(formattedUserName) ? null : (
        <span
          style={{
            lineHeight: "14px",
            fontWeight: 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "9.4px",
          }}
        >
          By <span style={{ fontWeight: 400 }}>{formattedUserName}</span> on{" "}
          <span style={{ fontWeight: 400 }}>
            {formatDateTime(updatedByUserDate)}
          </span>
        </span>
      )}
    </Flx>
  );
};

export default CellRendererLoanFileStatus;
